/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
import { l } from '@atproto/lex-schema';
const $nsid = 'org.okazu-diary.material.defs';
export { $nsid };
const tag = /*#__PURE__*/ l.typedObject($nsid, 'tag', 
/*#__PURE__*/ l.object({
    value: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
    lang: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'language' })),
}));
export { tag };
//# sourceMappingURL=defs.defs.js.map